
export const GET_USUARIO = `
    query getUsuario($usuarioID: ID!) {
        getUsuario(id: $usuarioID) {
            usuarioID
            nombreUsuario
            proveedorID
            nombreProveedor
            aliasProveedor
            logotipoProveedor
            email
            estatusID
            estatus
            estatusDescripcion
            tipoID
            tipo
            tipoDescripcion
            fechaAlta
            empresasIDs
        }
    }
`;

export const GET_ALL_USUARIO = `
query filtroGetAll($filtro: InputGetUsuario){
    getAllUsuario(filtro:$filtro){
        usuarioID
        usuario
    }
}`;


export const TABLA_USUARIOS = `
    query filterUsuario($filtro: InputFilterUsuario!) {
        filterUsuario(filtro: $filtro) {
            paginas
            registros
            listado {
                usuarioID
                nombreUsuario
                email
                nombreProveedor
                estatus
                tipo
                fechaAlta
            }
        }
    }
`;

export const GET_EMPRESAS_USUARIO = `
    query getEmpresasUsuario($input: InputGetEmpresasUsuario!) {
        getEmpresasUsuario(input: $input) {
            empresaID
            rfc
            razonSocial
        }
    }
`;
